import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Form from 'flarum/common/components/Form';
import Stream from 'flarum/common/utils/Stream';
import extractText from 'flarum/common/utils/extractText';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';

/**
 * Modal to lock a discussion with an optional reason, or to edit the reason of
 * an already locked one. Opened from the discussion moderation controls; only
 * shown to actors with `canLock`. Saves via `discussion.save()` → PATCH
 * /api/discussions/{id} with `isLocked: true` and `lockReason`; the backend
 * authorizes both on the `lock` ability (flarum/lock permission).
 */
export default class LockDiscussionModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    this.discussion = this.attrs.discussion;
    this.reason = Stream(this.discussion.lockReason() || '');
  }
  className() {
    return 'LockDiscussionModal Modal--small';
  }
  title() {
    return app.translator.trans(this.discussion.isLocked() ? 'bhic.forum.lock.edit_reason_title' : 'bhic.forum.lock.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('bhic.forum.lock.reason_label')), m("textarea", {
      className: "FormControl",
      bidi: this.reason,
      rows: 4,
      placeholder: extractText(app.translator.trans('bhic.forum.lock.reason_placeholder'))
    })), m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, app.translator.trans(this.discussion.isLocked() ? 'bhic.forum.lock.save_reason_button' : 'bhic.forum.lock.submit_button')))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    const reason = this.reason().trim();
    return this.discussion.save({
      isLocked: true,
      lockReason: reason || null
    }).then(() => {
      // Same refresh flarum/lock does after its one-click lock, so the
      // "locked the discussion" event post appears in the stream.
      if (app.current.matches(DiscussionPage)) {
        app.current.get('stream').update();
      }
      m.redraw();
      this.hide();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('flarum-flarum', 'forum/components/LockDiscussionModal', LockDiscussionModal);